<template>
  <section class="section blog-section" id="blog">
    <div class="container">
      <h2 class="section-title">{{ $t('web.blog_title') }}</h2>
      <div class="blog-intro">
        <p>{{ $t('web.blog_intro') }}</p>
      </div>
      <div class="blog-cards">
        <div class="blog-card unified-card" v-for="content in contents" :key="content.id">
          <div class="blog-image" :style="getBackgroundImageStyle(content.blog_screenshot_img_url)"></div>
          <div class="blog-content">
            <div class="blog-meta">
              <span class="meta-time">
              <el-icon><Clock /></el-icon>
                {{ getReadTime(content.display_content) }} min read
              </span>
              <span class="meta-date">
                <el-icon><Calendar /></el-icon>
                {{ formatDate(content.updated_time) }}
              </span>
            </div>
            <h3 class="blog-title-main">{{ content.title }}</h3>
            <p class="blog-desc">{{ content.display_content }}</p>
            <div class="blog-btn-wrapper">
              <a :href="content.blog_link_url" class="cta-button blog-read-btn" target="_blank">{{ $t('web.read_guide') }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="read-more-wrapper">
        <a class="cta-button read-more-btn" @click.prevent="jumpToBlogWeb" href="https://familypro.io/en/blog" target="_blank">
          {{ $t('web.read_more') }}
          <el-icon style="vertical-align: middle; margin-left: 6px;"><ArrowRight /></el-icon>
        </a>
      </div>
    </div>
  </section>
</template>
<script>
const {defineAsyncComponent} = Vue;
import { addCustmEvent } from '@/loadCountly';
import { ArrowRight } from '@element-plus/icons-vue';

export default {
  name: "Blog",
  components: {
    CustomLoading: defineAsyncComponent(() => import(/* webpackChunkName: "customLoading" */ '@/components/CustomLoading.vue'))
  },
  data() {
    return {
      contents: []
    }
  },
  created() {
    this.getDiscovers();
  },
  methods: {
    getDiscovers() {
      this.$axios.get('/api/goods/blog-list')
        .then(response => {
          let result = response.data;
          if (result === null || result.code !== 100000 || result === undefined) {
            this.$message({
              type: 'error',
              message: result.message
            })
            return;
          }
          this.contents = result.data
        })
        .catch(error => {
          console.log("请求更多发现接口失败: ", error);
        })
    },
    getBackgroundImageStyle(url) {
      return {
        backgroundImage: `url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    },
    getReadTime(text) {
      // 简单估算：每分钟读200字
      if (!text) return 1;
      const words = text.split(/\s+/).length;
      return Math.max(1, Math.round(words / 200));
    },
    formatDate(dateVal) {
      if (!dateVal) return '';
      // 如果是数字或数字字符串，视为时间戳（秒或毫秒）
      let d;
      if (typeof dateVal === 'number' || /^\d+$/.test(dateVal)) {
        // 判断是秒还是毫秒
        d = new Date(
          dateVal.toString().length === 13
            ? Number(dateVal)
            : Number(dateVal) * 1000
        );
      } else {
        d = new Date(dateVal.replace(/-/g, '/'));
      }
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    },
    jumpToBlogWeb() {
      let properties = {
        "target_url": 'https://familypro.io/en/blog'
      }
      addCustmEvent('addCustmEvent', 'click', window.location.pathname, properties);
      window.open("https://familypro.io/en/blog", "_blank");
    }
  }
}
</script>
<style scoped>
.section.blog-section {
  padding: 40px 0;
  background: #fff;
}
.section-title {
  font-family: 'Alibaba Sans', sans-serif;
  font-size: 2rem;
  color: #121212;
  font-weight: 800;
  margin-bottom: 0.5em;
  text-align: center;
}
.blog-intro {
  text-align: center;
  color: #888;
  font-size: 1.1rem;
  margin-bottom: 2em;
}
.blog-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem 2rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;
}
.blog-card.unified-card {
  display: flex;
  flex-direction: column;
  padding: 0;
  min-height: 350px;
  overflow: hidden;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  transition: box-shadow 0.2s, transform 0.2s;
}
.blog-card.unified-card:hover {
  box-shadow: 0 8px 32px rgba(251,113,60,0.18);
  transform: translateY(-6px) scale(1.03);
}
.blog-image {
  width: 100%;
  height: 220px;
  background-size: cover;
  background-position: center;
  border-radius: 24px 24px 0 0;
}
.blog-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1.2rem 1.2rem 1.5rem 1.2rem;
}
.blog-meta {
  color: #FB713C;
  font-size: 0.98rem;
  margin-bottom: 0.7em;
  display: flex;
  gap: 1.2em;
  align-items: center;
  justify-content: center;
  font-family: 'Alibaba Sans', sans-serif;
}
.blog-meta .meta-time,
.blog-meta .meta-date {
  color: #888;
}
.blog-meta .meta-time i,
.blog-meta .meta-date i {
  color: #FB713C;
}
.blog-title-main {
  font-size: 1.18rem;
  font-weight: 800;
  color: #121212;
  margin: 0 0 0.5em 0;
  text-align: center;
  line-height: 1.3;
  font-family: 'Alibaba Sans', sans-serif;
}
.blog-desc {
  color: #444;
  font-size: 1rem;
  margin-bottom: 1.5em;
  flex: 1;
  text-align: center;
  font-family: 'Alibaba Sans', sans-serif;
  line-height: 1.7;
}
.blog-btn-wrapper {
  display: flex;
  justify-content: center;
}
.cta-button.blog-read-btn,
.cta-button.read-more-btn {
  background: #fff7f0;
  color: #FB713C;
  border-radius: 999px;
  font-weight: 700;
  font-size: 1.08rem;
  padding: 0.7em 2.2em;
  box-shadow: 0 2px 8px rgba(251,113,60,0.08);
  border: none;
  margin: 0 auto;
  transition: background 0.2s, color 0.2s;
  font-family: 'Alibaba Sans', sans-serif;
  display: inline-flex;
  align-items: center;
  width: auto;
  text-decoration: none;
}
.cta-button.blog-read-btn:hover,
.cta-button.read-more-btn:hover {
  background: #FB713C;
  color: #fff;
}
.read-more-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 0.5em;
  margin-bottom: 2em;
}
.cta-button.read-more-btn {
  background: #fff7f0;
  color: #FB713C;
  border-radius: 999px;
  font-weight: 700;
  font-size: 1.08rem;
  padding: 0.7em 2.2em;
  box-shadow: 0 2px 8px rgba(251,113,60,0.08);
  border: none;
  margin: 0 auto;
  transition: background 0.2s, color 0.2s;
  font-family: 'Alibaba Sans', sans-serif;
  display: inline-flex;
  align-items: center;
  width: auto;
}
@media (max-width: 1100px) {
  .blog-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 700px) {
  .blog-cards {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }
  .blog-card.unified-card {
    padding: 0;
  }
  .section-title { font-size: 1.3rem; }
  .blog-intro { font-size: 1rem; }
}
</style>